import useSWR, { SWRConfiguration } from 'swr';

import { fetchFromNewApi } from '~/services/Http';
import { APIs } from '~/services/Http/internalAPIs';
import { browserLogError } from '~/utils/helper';

export const useLatestTemplateVersion = (swrConfig?: SWRConfiguration) => {
  const { data, mutate, ...rest } = useSWR<{ version: string }>(
    ['latestTemplateVersion'],
    () =>
      fetchFromNewApi(APIs.forms.getLatestVersion(), {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      }).then((r) => r.json()),
    { revalidateOnFocus: false, ...swrConfig },
  );

  const updateTemplateVersion = async (formId: string) => {
    try {
      const updatedData = await fetchFromNewApi(
        APIs.forms.updateVersion(formId),
        {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
        },
      ).then((r) => r.json());

      mutate(updatedData);
      return updatedData;
    } catch (error) {
      browserLogError('Error updating template version:', error);
    }
  };

  return {
    data,
    updateTemplateVersion,
    ...rest,
  };
};
